import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import WhoAreWe from './pages/about/WhoAreWe';
import WhyItMatters from './pages/about/WhyItMatters';
import OurTeam from './pages/about/OurTeam';

// Academy
import YOCILABAcademy from './pages/programs/YOCILABAcademy';
import ABETA from './pages/programs/ABETA';
import YociLabHub from './pages/YociLabHub';
import CreativeSpace from './pages/CreativeSpace';
import Ventures from './pages/Ventures';

// Youth Summit
import YouthSummit from './pages/YouthSummit';
import CampusTour from './pages/YouthSummitSubPages/CampusTour';
import SummitExperience from './pages/YouthSummitSubPages/SummitExperience';
import InnovationChallenge from './pages/YouthSummitSubPages/InnovationChallenge';
import SummitFellowship from './pages/YouthSummitSubPages/SummitFellowship';
import SummitRegister from './pages/YouthSummitSubPages/SummitRegister';

// Other Pages
import SignatureEvents from './pages/SignatureEvents';
import Seed4Impact from './pages/Seed4Impact';
import Contact from './pages/Contact';
import Donate from './pages/Donate';
import NotFound from './pages/NotFound';
import ImpactStoryDetail from './components/ImpactStoryDetail';
import ImpactStoriesPage from './pages/ImpactStoriesPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ScrollToTop />
          <Header />
          <Routes>
            {/* Home */}
            <Route path="/" element={<Home />} />

            {/* About */}
            <Route path="/about" element={<WhoAreWe />} />
            <Route path="/about/who-are-we" element={<WhoAreWe />} />
            <Route path="/about/why-it-matters" element={<WhyItMatters />} />
            <Route path="/about/our-team" element={<OurTeam />} />

            {/* Academy & Programs */}
            <Route path="/academy" element={<YOCILABAcademy />} />
            <Route path="/programs/yocilab-academy" element={<YOCILABAcademy />} />
            <Route path="/abeta" element={<ABETA />} />
            <Route path="/programs/abeta" element={<ABETA />} />
            <Route path="/programs/yocilab-hub" element={<YociLabHub />} />
            <Route path="/creative-space" element={<CreativeSpace />} />

            {/* Youth Summit */}
            <Route path="/youth-summit" element={<YouthSummit />} />
            <Route path="/youth-summit/register" element={<SummitRegister />} />
            <Route path="/youth-summit/campus-tour" element={<CampusTour />} />
            <Route path="/youth-summit/summit-experience" element={<SummitExperience />} />
            <Route path="/youth-summit/innovation-challenge" element={<InnovationChallenge />} />
            <Route path="/youth-summit/fellowship" element={<SummitFellowship />} />
            <Route path="/register" element={<SummitRegister />} />
            <Route path="/summit-registration" element={<SummitRegister />} />

            {/* Hub / Ventures / Events */}
            <Route path="/ventures" element={<Ventures />} />
            <Route path="/signature-events" element={<SignatureEvents />} />
            <Route path="/seed4impact" element={<Seed4Impact />} />
            <Route path="/impact-stories" element={<ImpactStoriesPage />} />
            <Route path="/impact-story/:id" element={<ImpactStoryDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />

            {/* Fallback 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
